import { api } from '@fno/service/global.js'

const makeFilter = map => Object.keys(map).reduce((list, key) => {
    if (map[key]) {
        list.push(`filter.${key}=${Array.isArray(map[key]) ? map[key].join(',') : map[key]}`)
    }
    return list
}, []).join('&')

export const getUsersWithSchoolAccess = ({ schoolId, roles }) => api
    .get(`/v2/users?${makeFilter({
        schoolIds: schoolId,
        roles
    })}`)
    .then(response => response.data)

export const patchUser = ({ user }) => api
    .patch(`/v2/users/${user.id}`, {
        data: user
    })
    .then(response => {
        return response.data
    })

export const createUser = ({ user }) => api
    .post(`/v2/users`, {
        data: user
    })
    .then(response => {
        return response.data
    })
    .catch(error => {
        return Promise.reject(error)
    })

export const getCurrentUser = () => api
    .get('/v2/currentUser')
    .then(response => {
        return response.data
    })
